// C12 (U4): Services toasts sit at the bottom centre with an explicit
// duration (4 s; 10 s when the toast carries an action such as Undo), so they
// never cover the plan header and never linger. Passed per toast only: the
// app-wide <Toaster> in App.js is unchanged.
//
// Every Services toast carries the class `services-toast`. The app-wide
// index.css pins `top` on every toaster list (`[data-sonner-toaster] { top:
// max(50px, …) !important }`), which is right for the app's top toasts but
// stretches a bottom list from 50px to the bottom of the screen, where its
// invisible box swallows taps and a resting pointer pauses the toast. One rule,
// injected with the first Services toast and matching only a list that holds a
// Services toast, releases that `top` again. index.css is untouched; flag-off
// users never load this module.
import { toast as sonner } from 'sonner';

export const TOAST_MS = 4000;
export const UNDO_MS = 10000;
export const TOAST_CLASS = 'services-toast';
const STYLE_ID = 'services-toast-style';

function ensureStyle() {
  if (typeof document === 'undefined' || document.getElementById(STYLE_ID)) return;
  const el = document.createElement('style');
  el.id = STYLE_ID;
  el.textContent = `[data-sonner-toaster]:has(> [data-sonner-toast].${TOAST_CLASS}) { top: auto !important; }`;
  document.head.appendChild(el);
}

const withDefaults = (fn) => (message, opts = {}) => {
  ensureStyle();
  return fn(message, {
    position: 'bottom-center',
    duration: opts.action ? UNDO_MS : TOAST_MS,
    ...opts,
    className: [TOAST_CLASS, opts.className].filter(Boolean).join(' '),
  });
};

export const toast = Object.assign(withDefaults(sonner), {
  success: withDefaults(sonner.success),
  error: withDefaults(sonner.error),
  info: withDefaults(sonner.info),
  warning: withDefaults(sonner.warning),
  message: withDefaults(sonner.message),
  dismiss: sonner.dismiss,
});

export default toast;
